import { IApiResponse } from "../../../@types/api-response.type";
import { IGrid } from "../../../@types/grid.type";
import { IKeyValue } from "../../../@types/key-value.type";
import { IAuditFilter, IAuditLogDetail, IAuditLogGrid } from "../../../@types/audit.type";
import { Api } from "../ApiConfig";
import { ApiException } from "../ApiException";
import { getErrorMessage } from "../../../utils/utils";

export const searchAuditLogs = async (filter: IAuditFilter) => {
  try {
    const { data } = await Api.post<IApiResponse<IGrid<IAuditLogGrid>>>(`/api/Audit/SearchAuditLogs`, filter);
    return data;
  } catch (error) {
    throw new ApiException(getErrorMessage(error, "Erro ao buscar registros de auditoria"));
  }
};

export const getAuditLogById = async (id: string) => {
  try {
    const { data } = await Api.get<IApiResponse<IAuditLogDetail>>(`/api/Audit/GetAuditLogById?id=${id}`);
    return data;
  } catch (error) {
    throw new ApiException(getErrorMessage(error, "Erro ao buscar detalhe do registro de auditoria"));
  }
};

export const getRecordTimeline = async (entityName: string, entityId: string, skip: number, take: number) => {
  try {
    const { data } = await Api.get<IApiResponse<IGrid<IAuditLogGrid>>>(
      `/api/Audit/GetRecordTimeline?entityName=${entityName}&entityId=${entityId}&skip=${skip}&take=${take}`
    );
    return data;
  } catch (error) {
    throw new ApiException(getErrorMessage(error, "Erro ao buscar histórico do registro"));
  }
};

export const getAuditableEntities = async () => {
  try {
    const { data } = await Api.get<IApiResponse<IKeyValue[]>>(`/api/Audit/GetAuditableEntities`);
    return data;
  } catch (error) {
    throw new ApiException(getErrorMessage(error, "Erro ao buscar módulos auditáveis"));
  }
};

export const getAuditActions = async () => {
  try {
    const { data } = await Api.get<IApiResponse<IKeyValue[]>>(`/api/Audit/GetAuditActions`);
    return data;
  } catch (error) {
    throw new ApiException(getErrorMessage(error, "Erro ao buscar tipos de ação"));
  }
};
